import { z } from 'zod';
import type { CountryRegionToken } from '@sleed/bizcommerce-api';

/**
 * Region (Νομός) edit form. Mirrors `CountryRegionToken` and the legacy admin grid
 * (Core/client/admin/src/pages/System/CountryRegions/index.js): cid (country) required,
 * nm required ≤100, cd ≤50. `erpcd` is carried through so an update never wipes it.
 */
export const countryRegionSchema = z.object({
	id: z.number().optional(),
	cid: z.number().int().positive('validation.required'),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	cd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int(),
	erpcd: z.string().nullable()
});

export type CountryRegionFormValues = z.infer<typeof countryRegionSchema>;

export const EMPTY_COUNTRY_REGION: CountryRegionFormValues = { cid: 0, nm: '', cd: null, iv: true, si: 0, erpcd: null };

export function tokenToForm(token: CountryRegionToken): CountryRegionFormValues {
	return {
		id: token.id,
		cid: token.cid ?? 0,
		nm: token.nm ?? '',
		cd: token.cd ?? null,
		iv: token.iv ?? false,
		si: token.si ?? 0,
		erpcd: token.erpcd ?? null
	};
}

export function formToToken(form: CountryRegionFormValues): CountryRegionToken {
	return {
		id: form.id,
		cid: form.cid,
		nm: form.nm.trim(),
		cd: form.cd?.trim() || null,
		iv: form.iv,
		si: form.si,
		erpcd: form.erpcd
	};
}
